import { Injectable } from '@angular/core';
import { gql, Mutation } from 'apollo-angular';

import { CUSTOM_LINE_FRAGMENT } from 'graphql/fragments/custom-line';
import { PRODUCT_LINE_FILTERED_VARIABLES_FRAGMENT } from 'graphql/fragments/filtered-variables';
import { PRODUCT_LINE_CONFIGURATION_FILTERS_FRAGMENT } from 'graphql/fragments/filters-configuration-section';
import { PRODUCT_LINE_FRAGMENT } from 'graphql/fragments/product-line';
import { PRODUCT_LINE_PRODUCT_FRAGMENT } from 'graphql/fragments/product-line-product';
import { PRODUCT_LINE_VARIABLES_FRAGMENT } from 'graphql/fragments/product-line-variables';
import { QUOTE_PRICING_FRAGMENT } from 'graphql/fragments/quote-pricing';
import { QUOTE_PRICING_STATE_FRAGMENT } from 'graphql/fragments/quote-pricing-state';
import { Mutation as RootMutation } from 'graphql/models/generated';

export const COPY_POSITIONS_CUSTOM_MUTATION = gql`
  mutation copyPositionsCustom(
    $documentVersion: DocumentVersionInput!,
    $lineIds: [String!]!,
    $withPricing: Boolean = true,
    $withFilters: Boolean = false
  ) {
    custom {
      customCopyLines(
        documentRevision: $documentVersion
        lineIds: $lineIds
      ) {
        newLines {
          ...ProductLineFragment
          ...ProductLineProductFragment
          ...ProductLineVariablesFragment
          ...ProductLineFilteredVariablesFragment
          ...ProductLineConfigurationFiltersFragment @include(if: $withFilters)
          ...CustomLineFragment
        }
        quote {
          status
          snkModifier {
            profile {
              firstName
              lastName
            }
          }
          ...QuotePricingFragment @include(if: $withPricing)
          ...QuotePricingStateFragment @skip(if: $withPricing)
        }
      }
    }
  }
  ${PRODUCT_LINE_FRAGMENT}
  ${PRODUCT_LINE_PRODUCT_FRAGMENT}
  ${PRODUCT_LINE_VARIABLES_FRAGMENT}
  ${PRODUCT_LINE_FILTERED_VARIABLES_FRAGMENT}
  ${PRODUCT_LINE_CONFIGURATION_FILTERS_FRAGMENT}
  ${QUOTE_PRICING_FRAGMENT}
  ${QUOTE_PRICING_STATE_FRAGMENT}
  ${CUSTOM_LINE_FRAGMENT}
`;

@Injectable({
  providedIn: 'root'
})
export class CopyPositionsCustomMutation extends Mutation<RootMutation> {
  document = COPY_POSITIONS_CUSTOM_MUTATION;
}
